import OnboardingType from "@teaming/common-enums/OnboardingType";
import OnboardingStep from "@teaming/common-enums/OnboardingStep";
const NewUserOnboardingStep = OnboardingStep.enumFor( { version: 3, isTeamLead: true, } );
const InvitedUserOnboardingStep = OnboardingStep.enumFor( { version: 3, isTeamLead: false, } );

const newUserRouteMap = {
	[ NewUserOnboardingStep.WELCOME ]: "/onboarding/new-user/welcome",
	[ NewUserOnboardingStep.ABOUT_YOUR_TEAM ]: "/onboarding/new-user/you-and-your-team",
	[ NewUserOnboardingStep.SESSION_SIGNUP ]: "/onboarding/new-user/session-signup",
};

const invitedUserRouteMap = {
	[ InvitedUserOnboardingStep.WELCOME ]: "/onboarding/invited-user/welcome",
	[ InvitedUserOnboardingStep.PERSONAL_GROWTH ]: "/onboarding/invited-user/personal-growth",
};

// eslint-disable-next-line no-unused-vars
export default function configureNavigation( { foundationModules, router, authService, config, } ) {
	foundationModules.navigation = {
		getCurrentRoute() {
			return router.currentRoute.value;
		},

		getLocationHref() {
			return window.location.href;
		},

		getRouteParam( paramName ) {
			return router.currentRoute.value.params?.[ paramName ] || "";
		},

		getRouterInstance() {
			return router;
		},

		navigateToSignIn() {
			router.push( "/signin" );
		},

		navigateToSignUp() {
			router.push( "/signup" );
		},

		logout() {
			authService.logout();
		},

		navigateToOnboardingStep( { onboardingType, onboardingStep, } ) {
			const routeMap = ( onboardingType === OnboardingType.LEAD ) ?
				newUserRouteMap :
				invitedUserRouteMap;
			const routePath = routeMap[ onboardingStep ];

			if ( !routePath ) {
				throw new Error( `no route for onboarding type ${ onboardingType } and step ${ onboardingStep }` );
			}

			return router.push( routePath );
		},

		navigateToCoaching() {
			window.open( foundationModules.config.coachingLink, "_blank" );
		},

		navigateToDemo() {
			window.open( foundationModules.config.demoLink, "_blank" );
		},

		navigateToStripePayment( { personId, email, location, } ) {
			foundationModules.telemetry.user.paymentLinkClicked( { location, } );
			window.location.assign( `${ config.stripePaymentLink }?client_reference_id=${ personId }&prefilled_email=${ email }` );
		},

		navigateToMyGokrs() {
			router.push( "/goals" );
		},

		navigateToMyCommitments() {
			router.push( "/action-items" );
		},

		navigateToProfile() {
			router.push( "/me/profile" );
		},

		navigateToUserSettings() {
			router.push( "/me/settings" );
		},

		navigateToTeams() {
			return router.push( "/teams" );
		},

		navigateToTeam( { teamId, } ) {
			return router.push( `/team/${ teamId }` );
		},

		navigateToTeamPrivateStream( { teamId, } ) {
			router.push( `/team/${ teamId }/stream/private` );
		},

		navigateToTeamSharedStream( { teamId, subDocId, } ) {
			let newPath = `/team/${ teamId }/stream/shared`;
			if ( subDocId ) {
				newPath = `${ newPath }?note=${ subDocId }`;
			}
			router.push( newPath );
		},

		navigateToInbox() {
			router.push( { name: 'Inbox' } );
		},

		navigateToTeamSettings( { teamId, } ) {
			router.push( `/team/${ teamId }/settings` );
		},

		navigateToTeamWorkStyle( { teamId, } ) {
			router.push( `/team/${ teamId }/workstyle` );
		},

		navigateToTeamCommitments( { teamId, } ) {
			router.push( `/team/${ teamId }/commitments` );
		},

		navigateToTeamHealth( { teamId, } ) {
			router.push( `/team/${ teamId }/health` );
		},

		navigateToOneOnOnes() {
			router.push( "/one-on-ones" );
		},

		navigateToOneOnOnePrivateStream( { teamId, } ) {
			router.push( `/one-on-one/${ teamId }/stream/private` );
		},

		navigateToOneOnOneSharedStream( { teamId, subDocId, } ) {
			let newPath = `/one-on-one/${ teamId }/stream/shared`;
			if ( subDocId ) {
				newPath = `${ newPath }?note=${ subDocId }`;
			}
			router.push( newPath );
		},

		navigateToOneOnOneWorkstyles( { teamId, } ) {
			router.push( `/one-on-one/${ teamId }/workstyles` );
		},

		navigateToOneOnOneTeammate( { teamId, } ) {
			router.push( `/one-on-one/${ teamId }/teammate` );
		},

		navigateToOneOnOneCommitments( { teamId, } ) {
			router.push( `/one-on-one/${ teamId }/commitments` );
		},

		navigateToOneOnOneSettings( { teamId, } ) {
			router.push( `/one-on-one/${ teamId }/settings` );
		},

		//
		// TODO: start migrating navigation above to namespaces below
		//

		gokr: {
			navigateToMyGoals() {
				router.push( "/goals" );
			},
			navigateToNewGoal() {
				router.push( "/goals/new" );
			},
			navigateToMyGoal( { goalId, } ) {
				router.push( `/goals/${ goalId }` );
			},
			navigateToMyNewKeyResult( { goalId, } ) {
				router.push( `/goals/${ goalId }/key-result/new` );
			},
			navigateToMyKeyResult( { goalId, keyResultId, } ) {
				router.push( `/goals/${ goalId }/key-result/${ keyResultId }` );
			},
		},

		oneOnOne: {
			gokr: {
				navigateToGoals( { teamId, } ) {
					router.push( `/one-on-one/${ teamId }/goals` );
				},

				navigateToGoal( { teamId, goalId, } ) {
					router.push( `/one-on-one/${ teamId }/goal/${ goalId }` );
				},

				navigateToNewGoal( { teamId, } ) {
					router.push( `/one-on-one/${ teamId }/goal/new` );
				},

				navigateToNewKeyResult( { teamId, goalId, } ) {
					router.push( `/one-on-one/${ teamId }/goal/${ goalId }/key-result/new` );
				},

				navigateToKeyResult( { teamId, goalId, keyResultId, } ) {
					router.push( `/one-on-one/${ teamId }/goal/${ goalId }/key-result/${ keyResultId }` );
				},
			},
		},

		team: {
			gokr: {
				navigateToGoals( { teamId, } ) {
					router.push( `/team/${ teamId }/goals` );
				},

				navigateToGoal( { teamId, goalId, } ) {
					router.push( `/team/${ teamId }/goal/${ goalId }` );
				},

				navigateToNewGoal( { teamId, } ) {
					router.push( `/team/${ teamId }/goal/new` );
				},

				navigateToNewKeyResult( { teamId, goalId, } ) {
					router.push( `/team/${ teamId }/goal/${ goalId }/key-result/new` );
				},

				navigateToKeyResult( { teamId, goalId, keyResultId, } ) {
					router.push( `/team/${ teamId }/goal/${ goalId }/key-result/${ keyResultId }` );
				},
			},
		},
	};
}
